<div class="modal-dialog modal-xl mt-0 mb-0" role="document">
    <div class="modal-content" style="min-height: 450px;">
        <div class="modal-body padding">
            <button type="button" class="btn-close float-end" data-bs-dismiss="modal"
                (click)="bsModalRef.hide()"></button>
            <div class="col-lg-12 col-md-12 col-sm-12 mb-4" style="flex-direction: row;">
                <h4 class="titulo_seccao">Fotos</h4>
                <div class="form-check form-switch" style="margin-left: 5px;" *ngIf="heEmpresaDonaDoOrcamento() && !readonly"
                    title="Ao Ativar essa opção qualquer empresa que receber seu orçamento poderá excluir as fotos">
                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                        (change)="alternarPermissaoExclusaoDeFotos()" checked>
                    <label class="form-check-label" for="flexSwitchCheckDefault"><span>Permitir Exclusão das fotos por terceiros</span></label>
                </div>
            </div>
            <div class="conatiner p-2">
                <div class="row" *ngIf="!readonly">
                    <form>
                        <div class="col-12 d-flex">
                            <div style="width: 95%;">
                                <div class="input-group mb-3">
                                    <input type="file" class="form-control d-none mr-1" id="inputGroupFile02" multiple #fotos
                                        style="display:block !important;">
                                    <button (click)="postFotos(fotos)" class="input-group-text btn btn-outline-dark"><i
                                            class="fa fa-download mr-2" aria-hidden="true"></i>Enviar Fotos</button>
                                </div>
                            </div>
                            <div style="width: 2%; margin-left: 1%;">
                                <button *ngIf="existeImage && (permitirExclusaoTerceiro || heEmpresaDonaDoOrcamento())" (click)="multDeleteImage()"
                                    class="input-group-text btn btn-danger"
                                    title="Apagar fotos selecionadas"><i style="margin: 0;"
                                        class="fa fa-trash mr-2" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row" style="max-height: 65vh;overflow-y: scroll;">
                    <div class="fotos-div">
                        <div class="foto-card" *ngFor="let image of imagens; let i = index">
                            <div class="col-12 d-flex justify-content-end" *ngIf="!readonly && (permitirExclusaoTerceiro || heEmpresaDonaDoOrcamento())" >
                                <input type="checkbox" class="select-img form-check-input" [id]="'check'+i" style="margin-right: 15px;"
                                    (click)="alteraCheck(image.arquivo)">
                            </div>
                            <div class="img m-3 img-fluid align-items-center d-flex"
                                style="height:200px; background-image: url({{image.url}}); background-position: center; border-radius: 5px;"
                                (click)="alteraCheck(image.arquivo, 'check'+i)">
                                <a rel="galeria" href="{{image.url}}" target="_blank" class="btn-modal"><i class="fa fa-eye ico-im-m"
                                        aria-hidden="true" (click)="alteraCheck(image.arquivo, 'check'+i)"></i></a>
                                <button  class="btn-modal" (click)="deleteImage(image);alteraCheck(image.arquivo, 'check'+i)"
                                    *ngIf="(permitirExclusaoTerceiro || heEmpresaDonaDoOrcamento()) && !readonly"><i
                                        class="fa fa-trash ico-im-m"
                                        aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>